export default __webpack_public_path__ + "static/media/91.551c88a4.jpg";